import * as actionTypes from '../constants/actionTypes';
export function changeProjectDeviceFrame(frame) {
    return {
        type: actionTypes.CHANGE_PROJECT_DEVICE_FRAME,
        frame: frame,
    };
}
export function changeProjectDeviceOrientation(orientation) {
    return {
        type: actionTypes.CHANGE_PROJECT_DEVICE_ORIENTATION,
        orientation: orientation,
    };
}
export function changeDeviceOrientation(orientation) {
    return {
        type: actionTypes.CHANGE_DEVICE_ORIENTATION,
        orientation: orientation,
    };
}
export function changeDeviceDetection(deviceDetection) {
    return {
        type: actionTypes.CHANGE_DEVICE_DETECTION,
        deviceDetection: deviceDetection,
    };
}
